/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface PatchedStyleCriterion
 */
export interface PatchedStyleCriterion {
  /**
   *
   * @type {number}
   * @memberof PatchedStyleCriterion
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedStyleCriterion
   */
  name?: string;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof PatchedStyleCriterion
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PatchedStyleCriterion
   */
  definition?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedStyleCriterion
   */
  example?: string;
  /**
   *
   * @type {number}
   * @memberof PatchedStyleCriterion
   */
  scale?: number;
}

/**
 * Check if a given object implements the PatchedStyleCriterion interface.
 */
export function instanceOfPatchedStyleCriterion(value: object): value is PatchedStyleCriterion {
  return true;
}

export function PatchedStyleCriterionFromJSON(json: any): PatchedStyleCriterion {
  return PatchedStyleCriterionFromJSONTyped(json, false);
}

export function PatchedStyleCriterionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedStyleCriterion {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    definition: json['definition'] == null ? undefined : json['definition'],
    example: json['example'] == null ? undefined : json['example'],
    scale: json['scale'] == null ? undefined : json['scale'],
  };
}

export function PatchedStyleCriterionToJSON(value?: Omit<PatchedStyleCriterion, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
    definition: value['definition'],
    example: value['example'],
    scale: value['scale'],
  };
}
